<template>
    <b-container fluid class="mt--7">
        <b-card :title="title">
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="input-group-orderTypePrepended"
                        label="Order Type Prepended:"
                        label-for="input-orderTypePrepended"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-checkbox
                            id="input-orderTypePrepended"
                            v-model="model.orderTypePrepended"
                            name="input-orderTypePrepended"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group
                        id="input-group-typeSize"
                        label="Type Size:"
                        label-for="input-typeSize"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-typeSize"
                            v-model="model.typeSize"
                            type="number"
                            min="0"
                            max="5"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-startNumber"
                        label="Start Number:"
                        label-for="input-startNumber"
                        label-class="font-weight-bold pt-0"
                        label-cols="3"
                    >
                        <b-form-input
                            id="input-startNumber"
                            v-model="model.startNumber"
                            type="number"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <div class="text-right">
                        <b-button
                            class="my-4"
                            variant="primary"
                            :disabled="updating ? true : false"
                            @click="updateSettings"
                            >{{ updating ? 'Updating...' : 'Update' }}</b-button
                        >
                    </div>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
const key = 'orderReferenceNoSettings'
import popupMixins from '@/mixins/popupMixins'
export default {
    name: 'OrderSettings',
    mixins: [popupMixins],
    data: () => ({
        title: 'Order Reference No Generator Settings',
        model: {},
        updating: false,
    }),

    computed: {
        settings() {
            const settings = this.$store.state.company.settings
            console.log('computed settings', settings)
            return settings
        },
    },

    watch: {
        settings: {
            handler: function(val) {
                console.log('watch settings', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },
    async mounted() {
        await this.$store.dispatch('company/fetchConfiguration', key)
        this.$nextTick(() => {
            this.updateModel(this.settings)
        })
    },

    methods: {
        updateModel(settings) {
            const set_value = (key, value) => this.$set(this.model, key, value)
            console.log('update settings', settings)
            try {
                const { configurations } = settings
                const data = configurations[0][0]
                console.log('update data', data)

                const {
                    startNumber,
                    orderTypePrepended,
                    typeSize,
                } = JSON.parse(data.text_value)
                set_value('typeSize', typeSize)
                set_value('startNumber', startNumber)
                set_value('orderTypePrepended', orderTypePrepended)
            } catch (err) {
                set_value('startNumber', null)
                set_value('typeSize', null)
                set_value('orderTypePrepended', null)
            }
            console.log('update model', this.model)
        },
        async updateSettings() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false
                this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })
                this.doToast('Success!', 'Settings Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
